export enum BusinessType {
  Company = "Company",
  IndividualCompany = "IndividualCompany",
  Person = "Person",
}

export const businessTypeLabels: Record<string, string> = {
  [BusinessType.Company]: "Azienda",
  [BusinessType.IndividualCompany]: "Ditta individuale",
  [BusinessType.Person]: "Persona Fisica",
};
